import React, { Component } from 'react';
import {MainLayout} from 'components/layouts';
import {ProductOfBusinessList} from 'components/fair/fair-product';
import {Link} from 'react-router-dom';

export default class FairProductsOfBusiness extends Component {

  render() {
    return (
      <MainLayout>
        <div>
          <div className='mb15'>
            <Link className='btn-back' to={`/fair/${this.props.match.params.id}`}><i className='fa fa-chevron-left' />Quay về trang chi tiết hội chợ</Link>
          </div>
          <div className='wrap-heading'>
            <h1>Các sản phẩm của doanh nghiệp</h1>
            <div className='list-actions'>
              <Link to={`/fair/${this.props.match.params.id}/business/${this.props.match.params.idBusiness}/products/add`} className='blue'>Thêm sản phẩm vào hội chợ</Link>
              <Link to={`/fair/${this.props.match.params.id}/products/add`}>Tạo mới sản phẩm</Link>
            </div>
          </div>
          <ProductOfBusinessList match={this.props.match}/>
        </div>
      </MainLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/fair/fair-products/FairProductsOfBusiness.jsx